export default {
  Create: require('./Create').default,
  AddAct: require('./AddActivity').default,
  Edit: require('./Edit').default,
}